import React, {useEffect} from "react"
import {withPrefix} from "gatsby"
import styled from "styled-components"
import Title from "@airasia/phoenix-components/components/Title"
import Image from "@airasia/phoenix-components/components/Image"
import Text from "@airasia/phoenix-components/components/Text"
import Link from "@airasia/phoenix-components/components/Link"
import Button from "@airasia/phoenix-components/components/Button"
import Carousel from "@airasia/phoenix-widgets/widgets/Carousel"
import { UAParser } from 'ua-parser-js'

import UNIVERSAL_HEADER_DATA from "../data/en/header"
import HERO_BANNER_DATA from "../data/en/herobanner"
import FIRST_CAROUSEL_DATA from "../data/en/incentives"
import CAPTAINNEW_CAROUSEL_DATA from "../data/en/captainNew"
import CAPTAIN_CAROUSEL_DATA from "../data/en/captain"
import CAPTAIN2_CAROUSEL_DATA from "../data/en/captain2"
import CAPTAIN4_CAROUSEL_DATA from "../data/en/captain4"
import Layout from "../components/layout"
import "../css/main.css"
import {fireGtmEvent} from "../utils/functions"

const GrayWrapper = styled.div`
   background-color: #ededed;
   padding: 40px 0 10px 0;
   margin-bottom: 60px;
`

const ContentWrapper = styled.div`
  max-width: 625px;
  margin-bottom: 24px;

#button-gap {margin: 10px;}

  @media only screen and (min-width: 720px) {
    width: 90%;
    max-width: 976px;
    margin: 0 auto 48px;
  }

  @media only screen and (min-width: 1025px) {
    width: 90%;
    max-width: 1224px;
    margin: 0 auto 48px;
  }
`

const TitleWrapper = styled.div`
  margin-bottom: 3em;

  #subtitle {
    font-size: 1.2rem;
    line-height: 2.2rem;
  }

  h2 {
    margin-bottom: -35px;
    font-size: 1.8rem;
  }

a {
    color: rgb(220, 50, 36);
    text-decoration: none;
  }
  @media only screen and (max-width: 720px){
    width: 90%;
    margin: 2em auto;

    #incentivesprogram {
      font-size: 24px;
      line-height: 28px;
      margin-bottom: 10px;
    }

    #subtitle {
      font-size: 1rem;
      line-height: 1.5rem;
    }
  }
`

const LobContainer = styled.div`
 #intensive-title{ margin:1rem auto;}
 #incentivesprogram {font-size: 1.5rem;}
`

const MenusWrapper = styled.div`
  margin: 2% auto;
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  text-align:center;

  @media only screen and (max-width: 414px) {
    justify-content: center;
    margin:10% auto;
  }
`

const Menu = styled.div`
  display: block;
  justify-content: flex-start;
  text-align: center;
  width: 33%;
  border-radius:10px;
  cursor: pointer;

  #menu-icon {
    background: none;
    width:100%;
  }

  #intensive-title{margin:1em auto;}

  @media only screen and (max-width: 414px) {
    width: 90%;
  }

  `

const Download = styled.div`
  background-color: #ff0000;
  color: #fff;
  padding: 20px 50px;
`
const DownloadContent = styled.div`
  max-width: 850px;
  display: flex;
  margin: 0 auto;

  @media only screen and (max-width: 600px) {
    display: block;
  }
`
const AppDownload = styled.div`
  display: block;
  margin: 20px auto;
  width: 60%;

  #app-download-text {
    font-style: italic;
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 20px;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`
const DownloadAppWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`
const DownloadApp = styled.div`
  margin: 3px;

  #download-image {
    background-color: transparent;
  }
`
const SuperAppIconWrapper = styled.div`
  width: 15%;
  margin: auto;

  #superapp-image {
    background-color: transparent;
  }
  @media only screen and (max-width: 600px) {
    display: none;
  }
`
const DownloadButtonWrapper = styled.div`
  margin: auto;

  #buttonDownload {
    border-radius: 40px;
    font-style: italic;
  }
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

const IndexPage = () => {
    const updateLocale = (obj) => {
        window.location.href = withPrefix(obj.detail)
    }

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener("uhfLocaleChange", updateLocale)
        }
    }, [])

    let parser = new UAParser();
    console.log(parser.getResult());

    return (
        <Layout title="airasia's driver Benefits and Incentives Program | airasia"
                description="Join us and become an airasia Ride Driver to enjoy low platform fees, benefits & more! Register online now with airasia app."
                bannerData={HERO_BANNER_DATA}
                headerData={UNIVERSAL_HEADER_DATA}
        >
            <ContentWrapper>
            <LobContainer>
            <Title
                        accessible
                        inverted={false}
                        textAlign="left"
                        type="h1"
                        customProperties={{id: 'incentivesprogram'}}
                    >
                        Enjoy e-hailing's driver lower platform fees and many benefits
            </Title>
            {FIRST_CAROUSEL_DATA.length !== 0 && (
                    <MenusWrapper>
                        {FIRST_CAROUSEL_DATA.map((intensive) => {
                        return (
                            <Menu>
                            <Link
                    accessible
                    color="primary"
                    hoverUnderlined
                    href={intensive.url}
                    size="normal"
                    stopPropagation
                    target="tab"
                    theme="AIRASIA_CLASSIC"
                    type="normal"
                  >
                    <Image
                      accessible
                      src={intensive.image}
                      alt={intensive.title}
                      width="100%"
                      height="auto"
                      customProperties={{ id: 'menu-icon' }}
                    />
                  </Link>
                            <Link
                              accessible
                              bold
                              color="black"
                              hoverUnderlined
                              href="https://www.google.com"
                              size="normal"
                              stopPropagation
                              target="tab"
                              theme="AIRASIA_CLASSIC"
                              type="medium"
                                href={intensive.url}
                                customProperties={{ id: 'intensive-title' }}
                            >
                              {intensive.title}
                            </Link>
                            </Menu>
                        )
                        })}
                    </MenusWrapper>
                    )}
            </LobContainer>
            </ContentWrapper>
            <GrayWrapper>
            <ContentWrapper>
                <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={CAPTAINNEW_CAROUSEL_DATA.data}
                    heading={CAPTAINNEW_CAROUSEL_DATA.heading}
                    customProperties={{id: 'captain'}}
                    isHideFooter={false}
                    isLoading={false}
                    templateType="productCard"
                    fireGtm={fireGtmEvent}
                    gtmConsumerName="productCard"
                />
                <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={CAPTAIN_CAROUSEL_DATA.data}
                    heading={CAPTAIN_CAROUSEL_DATA.heading}
                    customProperties={{id: 'captain'}}
                    isHideFooter={false}
                    isLoading={false}
                    templateType="productCard"
                    fireGtm={fireGtmEvent}
                    gtmConsumerName="productCard"
                />
                <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={CAPTAIN2_CAROUSEL_DATA.data}
                    heading={CAPTAIN2_CAROUSEL_DATA.heading}
                    customProperties={{id: 'captain'}}
                    isHideFooter={false}
                    isLoading={false}
                    templateType="productCard"
                    fireGtm={fireGtmEvent}
                    gtmConsumerName="productCard"
                />
                <Carousel
                    accessible
                    allowLocaleFormat={true}
                    data={CAPTAIN4_CAROUSEL_DATA.data}
                    heading={CAPTAIN4_CAROUSEL_DATA.heading}
                    customProperties={{id: 'captain'}}
                    isHideFooter={false}
                    isLoading={false}
                    templateType="productCard"
                    fireGtm={fireGtmEvent}
                    gtmConsumerName="productCard"
                />
            </ContentWrapper>
            </GrayWrapper>
          <Download>
            <DownloadContent>
              <AppDownload>
                <Text
                  accessible
                  color="default"
                  display="inlineFlex"
                  hasToggle={false}
                  opacity={1}
                  tag="p"
                  theme="AIRASIA_CLASSIC"
                  translation={{}}
                  type="default"
                  customProperties={{
                    id: "app-download-text"
                  }}
                >
                  Join now on the airasia ride Driver App
                </Text>
                <DownloadAppWrapper>
                  <DownloadApp>
                    <Link href="https://apps.apple.com/my/app/airasia-ride-driver/id1336397298">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/app-store-badge.png" alt="AirAsia Mobile App - IOS"
                      />
                    </Link>
                  </DownloadApp>
                  <DownloadApp>
                    <Link href="https://play.google.com/store/apps/details?id=com.dacsee&hl=en&gl=US">
                      <Image
                        accessible
                        height="45px"
                        customProperties={{
                          id: "download-image"
                        }}
                        src="https://www.airasia.com/aa/images/logo/google-play-badge.png"
                        alt="AirAsia Mobile App - Google Play"
                      />
                    </Link>
                  </DownloadApp>
                </DownloadAppWrapper>
              </AppDownload>
              <SuperAppIconWrapper>
                <Image
                  accessible
                  width="90px"
                  customProperties={{
                    id: "superapp-image"
                  }}
                  src="https://www.airasia.com/aa/ride/images/super-app.png"
                  alt="airasia, The Asean Super App" />
              </SuperAppIconWrapper>
              <DownloadButtonWrapper>
                <Button
                  accessible
                  buttonType="link"
                  customProperties={{
                    id: "buttonDownload",
                    paddingBottom: "1rem",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    paddingTop: "1rem"
                  }}
                  fontWeight="normal"
                  href="https://airasia.onelink.me/F4uy/8102dac5"
                  size="normal"
                  target="tab"
                  type="normal"
                  color="default"
                  backgroundColor="#fff"
                  hoverBackgroundColor="default"
                  hoverColor="primary"
                >
                  Download Now
                </Button>
              </DownloadButtonWrapper>
            </DownloadContent>
          </Download>
        </Layout>
    )
}
export default IndexPage
